<template>
  <div
    class="OrderList-box"
    style="background-color: #f8f8f8;"
  >
    <nav>
      <!-- <router-link
        to="/"
        class="item"
      >
        我要检测
      </router-link> -->
      <router-link
        to="/OrderList"
        class="item active"
      >
        我的订单
      </router-link>
    </nav>
    <div
      class="OrderList"
      id="OrderList"
      v-if="OrderList.length>0"
    >
      <div
        class="item"
        v-for="(item,index) in OrderList"
        :key="index"
        v-if="OrderListFlag"
      >
        <div class="top">
          <div class="name">
            订单号：{{item.orderNo}}
          </div>
          <div class="time">{{item.createTime|evaluateTime}}</div>
        </div>
        <div class="userOrderDetailList">
          <div
            class="userOrderDetailList-item"
            v-for="(v,i) in item.userOrderDetailList"
            :key="i"
          >
            {{v.productName}}
          </div>
        </div>
        <div class="bottom">
          <div class="price">￥<span>{{item.paymentAmount}}</span></div>
          <div
            class="seePresentation"
            v-if="!item.isInvoice"
            @click="goInvoice(item.orderNo,item.doctorsId)"
          >申请开票</div>
        </div>
      </div>
    </div>
    <div
      class="noTestingList"
      :style="{height:clientHeight-130+'px'}"
      v-else-if="OrderListFlag&&OrderList.length==0"
    >
      <div class="noTestingListContent">
        <img src="../../assets/images/updataFile/noTestingList-icon.png">
        <div class="txt">抱歉，未查询到任何订单</div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      OrderListFlag: false,
      userInfo: {},
      paging: {
        userId: 0,
        size: 10,
        current: 1
      },
      total: 0,
      OrderList: [],
      scrollLoadMoreFlag: true
    };
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      localStorage.removeItem("bindingUserInfoList");
      this.paging.userId = this.userInfo.id;
      // this.paging.userId = "1283601283951869953";
      this.getOrderList();
      window.addEventListener("scroll", this.scrollLoadMore);
      this.clientHeight = document.body.clientHeight;
      if (!this.$store.state.wxConfigFlag) this.$wxConfig();
    } else this.$goLogin();
  },
  methods: {
    /**
     * 获取有已完成的订单
     */
    getOrderList(flag) {
      this.$loading();
      this.$http
        .get(`/userOrder/getOrderPageModel`, {
          params: this.paging
        })
        .then(res => {
          this.$store.state.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              let arr = this.OrderList;
              if (flag) arr = [];
              for (let i = 0; i < list.length; i++) {
                arr.push(list[i]);
              }
              this.total = data.total;
              this.scrollLoadMoreFlag = true;
              this.OrderListFlag = true;
              this.OrderList = arr;
            }
          }
        })
        .catch(err => {
          this.OrderListFlag = true;
          this.$toots("系统正在升级，请稍后");
        });
    },
    /**
     * 滚动到底部加载更多
     */
    scrollLoadMore() {
      let size = this.paging.current * this.paging.size;
      if (this.scrollLoadMoreFlag && this.total > size) {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; // 兼容获取滚动条高度
        var scrollHeight = document.getElementById("OrderList")
          .scrollHeight; // 获取整个document的高度
        var clientHeight = document.body.clientHeight; //获取当前显示的高度
        if (clientHeight + scrollTop + 30 > scrollHeight) {
          this.scrollLoadMoreFlag = false;
          this.paging.current = this.paging.current + 1;
          this.getOrderList();
        }
      }
    },
    goInvoice(orderNo,doctorsId) {
      this.$router.push({
        name: "invoice",
        query: {
          orderNo: orderNo,
          doctorsId:doctorsId
        }
      });
    }
  },
  /**
   * 该组件卸载时，移除scrollToTop事件
   */
  destroyed() {
    window.removeEventListener("scroll", this.scrollLoadMore, false);
  }
};
</script>
<style lang="less" scoped>
.OrderList {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 20px;
  .item:first-child {
    margin-top: -134px;
  }
  .item {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 46px;
    background-color: #fff;
    border-radius: 20px;
    margin-bottom: 20px;
    box-shadow: 0 0 30px 0px rgba(193, 191, 191, 0.5);
    .top {
      display: flex;
      justify-content: space-between;
      .name {
        font-size: 30px;
        font-weight: 700;
        text-align: justify;
      }
      .time {
        font-size: 24px;
        color: #aaa;
        margin-top: 4px;
        padding-left: 10px;
      }
    }
    .userOrderDetailList {
      padding-top:10px;
      padding-bottom:10px;
      .userOrderDetailList-item {
        font-size: 26px;
        line-height: 50px;
        padding-top: 10px;
        text-align: justify;
      }
    }
    .bottom {
      height: 96px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26px;
      .seePresentation {
        padding-left: 30px;
        padding-right: 30px;
        height: 54px;
        line-height: 52px;
        color: #1968a8;
        border-radius: 54px;
        border: 1PX solid #1968a8;
      }
      .price {
        color: #1968a8;
        span {
          font-size: 34px;
        }
      }
    }
  }
}
.noTestingList {
  width: 690px;
  margin: 0 auto;
  margin-top: -134px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 30px 0px rgba(193, 191, 191, 0.5);
  .noTestingListContent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    width: 374px;
    height: 288px;
    display: block;
    margin: 0 auto;
  }
  .txt {
    font-size: 28px;
    line-height: 38px;
    color: #999999;
    text-align: center;
  }
}
</style>

